/* Persistent banner: text + icon + one action; no whole-surface animation. */
.banner {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border: var(--border-default) solid var(--color-border-default);
  border-left: var(--border-strong) solid var(--color-border-default);
  border-radius: var(--radius-small);
  background: var(--color-bg-surface);
}

.banner[data-tone='attention'] {
  border-left-color: var(--color-content-primary);
}

.banner[data-tone='positive'] {
  border-left-color: var(--color-positive-content);
  background: var(--color-positive-surface);
}

.banner[data-tone='negative'] {
  border-left-color: var(--color-negative-emphasis);
}

.icon {
  flex: none;
  margin-top: 2px;
  color: var(--color-content-secondary);
}

.banner[data-tone='negative'] .icon {
  color: var(--color-negative-content);
}

.banner[data-tone='positive'] .icon {
  color: var(--color-positive-content);
}

.body {
  display: grid;
  gap: var(--space-1);
  min-width: 0;
}

.title {
  margin: 0;
  color: var(--color-content-primary);
  font: var(--type-compact);
  font-weight: 600;
}

.action {
  margin-left: auto;
  flex: none;
}
